import { memo } from "react";

import { defaultToTrue, getAssetsImage } from "@Components/Modules/Helpers";

const Help = memo(
    (props: React.ImgHTMLAttributes<HTMLImageElement>) => (
        <img {...props} src={getAssetsImage(process.env.HelpIcon)} alt="Help icon" />
    ),
    defaultToTrue,
);

export default Help;
